<div class="dashboard-page container-page">
    <div class="title-page d-flex justify-content-between">
        <div class="title">
            Trao đổi dữ liệu kho hàng
        </div>
        <BreadcrumbComponent></BreadcrumbComponent>
    </div>
    <div style="background: #f7f8f9;height: 100%">
        <div class="container-fluid">
            <div class="card">
                <div class="card-body">
                    <div class="search-component d-flex flex-wrap">
                        <div class="col-sm-12 d-flex justify-content-between flex-wrap">
                        </div>
                    </div>
                    <div class="list-partners-component">
                        <div class="col-sm-12 d-flex gap-3 flex-wrap align-content-start flex-column align-items-start">
                            <div class="col-sm-4">
                                <InputTextNormal
                                        :label="dataExchangeDelivery.exchange_delivery_name.label"
                                        :id="dataExchangeDelivery.exchange_delivery_name.id"
                                        :placeholder="dataExchangeDelivery.exchange_delivery_name.placeholder"
                                        :value-default="dataExchangeDelivery.exchange_delivery_name.value"
                                        @inputValue="onChange($event, dataExchangeDelivery.exchange_delivery_name.id)"
                                        :error-text="dataExchangeDelivery.exchange_delivery_name.error"
                                        :is-error="dataExchangeDelivery.exchange_delivery_name.isError"
                                        @blur="validateForm($event, dataExchangeDelivery.exchange_delivery_name.id)"
                                        :required="dataExchangeDelivery.exchange_delivery_name.required"
                                ></InputTextNormal>
                            </div>
                            <div class="col-sm-4">
                                <SelectNormal
                                        :label="dataExchangeDelivery.store_id.label"
                                        :id="dataExchangeDelivery.store_id.id"
                                        :placeholder="dataExchangeDelivery.store_id.placeholder"
                                        :value-default="dataExchangeDelivery.store_id.value"
                                        @inputValue="onChange($event, dataExchangeDelivery.store_id.id)"
                                        :error-text="dataExchangeDelivery.store_id.error"
                                        :is-error="dataExchangeDelivery.store_id.isError"
                                        @blur="validateForm($event, dataExchangeDelivery.store_id.id)"
                                        :required="dataExchangeDelivery.store_id.required"
                                        :options="dataExchangeDelivery.store_id.options"
                                ></SelectNormal>
                            </div>
                            <div class="col-sm-4">
                                <SelectNormal
                                        :label="dataExchangeDelivery.warehouse_id.label"
                                        :id="dataExchangeDelivery.warehouse_id.id"
                                        :placeholder="dataExchangeDelivery.warehouse_id.placeholder"
                                        :value-default="dataExchangeDelivery.warehouse_id.value"
                                        @inputValue="onChange($event, dataExchangeDelivery.warehouse_id.id)"
                                        :error-text="dataExchangeDelivery.warehouse_id.error"
                                        :is-error="dataExchangeDelivery.warehouse_id.isError"
                                        @blur="validateForm($event, dataExchangeDelivery.warehouse_id.id)"
                                        :required="dataExchangeDelivery.warehouse_id.required"
                                        :options="dataExchangeDelivery.warehouse_id.options"
                                ></SelectNormal>
                            </div>
                            <div class="col-sm-4">
                                <SelectNormal
                                        :label="dataExchangeDelivery.partner_id.label"
                                        :id="dataExchangeDelivery.partner_id.id"
                                        :placeholder="dataExchangeDelivery.partner_id.placeholder"
                                        :value-default="dataExchangeDelivery.partner_id.value"
                                        @inputValue="onChange($event, dataExchangeDelivery.partner_id.id)"
                                        :error-text="dataExchangeDelivery.partner_id.error"
                                        :required="dataExchangeDelivery.partner_id.required"
                                        @blur="validateForm($event, dataExchangeDelivery.partner_id.id)"
                                        :options="dataExchangeDelivery.partner_id.options"
                                ></SelectNormal>
                            </div>
                            <div class="col-sm-4">
                                <SelectNormal
                                        :label="dataExchangeDelivery.delivery_id.label"
                                        :id="dataExchangeDelivery.delivery_id.id"
                                        :placeholder="dataExchangeDelivery.delivery_id.placeholder"
                                        :value-default="dataExchangeDelivery.delivery_id.value"
                                        @inputValue="onChange($event, dataExchangeDelivery.delivery_id.id)"
                                        :error-text="dataExchangeDelivery.delivery_id.error"
                                        :required="dataExchangeDelivery.delivery_id.required"
                                        @blur="validateForm($event, dataExchangeDelivery.delivery_id.id)"
                                        :options="dataExchangeDelivery.delivery_id.options"
                                ></SelectNormal>
                            </div>
                            <div class="col-sm-4">
                                <InputDateTimeNormal
                                        :label="dataExchangeDelivery.delivery_date.label"
                                        :id="dataExchangeDelivery.delivery_date.id"
                                        :placeholder="dataExchangeDelivery.delivery_date.placeholder"
                                        :value-default="dataExchangeDelivery.delivery_date.value"
                                        @inputValue="onChange($event, dataExchangeDelivery.delivery_date.id)"
                                        :error-text="dataExchangeDelivery.delivery_date.error"
                                        :required="dataExchangeDelivery.delivery_date.required"
                                        @blur="validateForm($event, dataExchangeDelivery.delivery_date.id)"
                                        :min="dataExchangeDelivery.delivery_date.min"
                                ></InputDateTimeNormal>
                            </div>
                            <div class="col-sm-4">
                                <InputTextareaNormal
                                        :label="dataExchangeDelivery.exchange_delivery_description.label"
                                        :id="dataExchangeDelivery.exchange_delivery_description.id"
                                        :placeholder="dataExchangeDelivery.exchange_delivery_description.placeholder"
                                        :value-default="dataExchangeDelivery.exchange_delivery_description.value"
                                        @inputValue="onChange($event, dataExchangeDelivery.exchange_delivery_description.id)"
                                        :error-text="dataExchangeDelivery.exchange_delivery_description.error"
                                        :is-error="dataExchangeDelivery.exchange_delivery_description.isError"
                                        @blur="validateForm($event, dataExchangeDelivery.exchange_delivery_description.id)"
                                        :required="dataExchangeDelivery.exchange_delivery_description.required"
                                ></InputTextareaNormal>
                            </div>
                            <div class="col-sm-12">
                                <div class="col-sm-12 d-flex justify-content-between align-content-center mb-2">
                                    <label class="col-form-label" for="listProducts">SẢN PHẨM</label>
                                </div>
                                <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="errorMessageApi.length > 0" v-for="(error, key) in errorMessageApi" :key="error">
                                    <span>{{error}}</span>
                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="removeError(key)">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="col-sm-12 d-flex justify-content-between align-items-center">
                                    <div class="d-flex align-content-center mb-2 gap-2">
                                        <InputCheckboxOne  id="storeDelivery" @inputValue="onChangeStoreDelivery($event)" :checked="useToStoreDelivery" :disabled="disabledStoreDelivery"></InputCheckboxOne>
                                        <div>Sử dụng làm mẫu dữ liệu giao hàng mới</div>
                                    </div>
                                    <div class="mb-2">
                                        <button-add-component :width="'200px'" :label="labelSelectProduct" @click="showModalProductList"></button-add-component>
                                    </div>
                                </div>
                                <table class="table">
                                    <thead>
                                    <tr>
                                        <th class="text-center" scope="col" v-for="header in dataHeaderTable" :key="header.order" :style="{ 'width': header.width }">{{header.label}}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-if="listProductsSelected.length > 0" v-for="(product, key) in listProductsSelected" :key="product.id">
                                        <td><div class="remove_product" @click="removeProduct(product.id, product.product_name)"><IconTrash></IconTrash></div></td>
                                        <td class="text-center">{{product.product_name}}</td>
                                        <td class="text-center">{{product.product_code}}</td>
                                        <td class="text-center">{{CommonService.formatPrice(product.product_price, 'VND')}}</td>
                                        <td class="text-center">
                                            <InputNumberComponent
                                                    :id="'product_' + product.id"
                                                    :value-default="product.product_selling_price"
                                                    @inputValue="onChangeProductSellingPrice($event, 'product_' + product.id)"
                                                    :isError="product.error_selling"
                                            ></InputNumberComponent>
                                        </td>
                                        <td class="text-center">
                                            <InputNumberComponent
                                                    :id="'product_' + product.id"
                                                    :value-default="product.product_quantity_set"
                                                    @inputValue="onChangeProductQuantity($event, 'product_' + product.id)"
                                                    :isError="product.error_empty_quantity"
                                            ></InputNumberComponent>
                                        </td>
                                        <td class="text-center">{{product.product_tax + '%'}}</td>
                                        <td class="text-center">{{product.product_unit}}</td>
                                        <td class="text-center">{{CommonService.formatPrice(product.total_price_origin, 'VND')}}</td>
                                        <td class="text-center">{{CommonService.formatPrice(product.total_price_tax, 'VND')}}</td>
                                    </tr>
                                    <tr v-if="listProductsSelected.length > 0">
                                        <td colspan="10" class="text-end">Tổng tiền: {{CommonService.formatPrice(totalPrice, 'VND')}}</td>
                                    </tr>
                                    <tr v-else>
                                        <td colspan="9" class="text-center">Chưa có sản phẩm được chọn!</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="col-sm-12 d-flex  justify-content-center">
                                <ButtonSearchComponent label="Gửi data giao hàng" @click="createDelivery"></ButtonSearchComponent>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<ModalDeliveryProductListComponent
        @showModalProduct="showModalProduct($event)"
        @searchProduct="eventSearchProduct($event)"
        @listProductsSelectedCurrent="eventGetListProductsSelected($event)"
        :eventClickShowModal="eventClickShowModal"
        :listProductsSelected="listProductsSelected"
></ModalDeliveryProductListComponent>
<LoadingComponent v-if="isLoading"></LoadingComponent>
<ExportBillComponent v-if="isShowBill" :billData="dataBillToPrint" @printDone="handlePrintSuccess" @cancel="handleCancel"/>
